/**
 * @license @tabler/icons-react v3.31.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCandleFilled = createReactComponent("filled", "candle-filled", "IconCandleFilled", [["path", { "d": "M14 9a2 2 0 0 1 2 2v10a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1v-10a2 2 0 0 1 2 -2z", "key": "svg-0" }], ["path", { "d": "M11.254 1.334a1 1 0 0 1 1.491 0l1.452 1.623a3 3 0 0 1 -4.196 4.28c-1.195 -1.07 -1.339 -2.889 -.297 -4.166z", "key": "svg-1" }]]);

export { IconCandleFilled as default };
//# sourceMappingURL=IconCandleFilled.mjs.map
